import React, { useEffect, useState } from 'react';
import Autocomplete, { createFilterOptions } from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import { CircularProgress } from "@material-ui/core";
import Box from "@material-ui/core/Box";
import { TextValidator } from 'react-material-ui-form-validator';
import useCommonApi from "../../api/useCommonApi";
import { traducirLabel, traducirMessage } from '../../blocks/traductor';

export interface IAutocomplete {
    clave: string
    descripcion?: string
    descripcionVista?: string
}

interface IAutocompleteProps {
    name: string
    source: string
    label: string
    placeholder?: string
    value: IAutocomplete | null
    filter?: any
    required: boolean
    onChange: <T>(event, optionSelected: T) => void
}

const AutocompleteMercanciaControl = ({
    name,
    value,
    source,
    onChange,
    filter,
    required
    
}: IAutocompleteProps) => {



    const [searchText, setSearchText] = useState('');
    const [options, setOptions] = React.useState<IAutocomplete[]>([]);
    const [loading, setLoading] = useState(false);
    const [valueText, setValueText] = useState('');

    const filterOptions = createFilterOptions({
        // matchFrom: 'start',
        stringify: (option: IAutocomplete) => option ? option.clave + option.descripcion : ''
    });

    const apiSource = useCommonApi();

    useEffect(() => {
        if (value && value.descripcion) {
            setValueText(value.descripcion);
        } else {
            setValueText(''); // Asegúrate de limpiar cuando value es null
        }
    }, [value]);
    

    useEffect(() => {
        if (searchText === '') {
            setOptions([]); // Limpia las opciones cuando el texto de búsqueda esté vacío
        } else {
            const timer = setTimeout(triggerChange, 1000);
            return () => clearTimeout(timer);
        }
    }, [searchText]);
    
    useEffect(() => {
        let isMounted = true; // Bandera para evitar actualizaciones en componentes desmontados
        const fetchOptions = async () => {
            setLoading(true);
            try {
                const result = await apiSource.obtenerAsync<IAutocomplete[]>(
                    source,
                    filter ? { ...filter } : {}
                );
                if (isMounted) {
                    setOptions(result); // Solo actualiza el estado si el componente está montado
                }
            } catch (error) {
                console.error("Error al cargar las opciones:", error);
            } finally {
                if (isMounted) {
                    setLoading(false);
                }
            }
        };
    
        fetchOptions();
    
        return () => {
            isMounted = false; // Marca que el componente se desmontó
        };
    }, [source, filter]); // Incluye solo las dependencias necesarias
    

    const triggerChange = (event) => {

        if (!value?.clave) {
            setLoading(true);
            (async () => {
                const data = { Texto: searchText, ...filter };
                const result = await apiSource.obtenerAsync<IAutocomplete[]>(source, data);
                setOptions(result);
                setLoading(false);
            })();
        }
        if (value?.descripcion) {
            /*setOptions([value]);
            setSearchText(value?.descripcion?.toString());*/
            setSearchText(event.target.value);
        }
        
    };

    const textChange = (event) => {
        setSearchText(event.target.value);
    };

    const handleChange = (event, optionSelected) => {
        if (!optionSelected) {
            setValueText('');
            onChange(event, null);
            //triggerChange(event);
        }
        if (event != null) {

            onChange(event, optionSelected)
        }
        if (optionSelected) {
            if (event == null) {
                event = { target: { value: optionSelected.descripcion } };
            }
            // setOptions(optionSelected);

            setValueText(optionSelected.descripcion);
            onChange(null, optionSelected);
        }
    };

    return (
        <>
            {required &&
                <Autocomplete
                    options={options}
                    defaultValue={value}
                    getOptionSelected={(option, value) => option.clave === value.clave}
                    getOptionLabel={option => option.descripcionVista ? option.descripcionVista : ''}
                    filterOptions={filterOptions}
                    onChange={handleChange}
                    renderOption={(option, { selected }) => (

                        <>

                            <Box display="flex" flexDirection="column" fontSize={14}>
                                <Box fontWeight="fontWeightLight" fontSize={12}>
                                    {option.descripcionVista}
                                </Box>
                            </Box>
                        </>
                    )}

                    loading={loading}
                    renderInput={params => (
                            <TextValidator
                            {...params}
                            onChange={textChange}
                            fullWidth
                            validators={[required ? 'required' : '']}
                            errorMessages={[traducirLabel(25)]}
                            name={name}
                            value={valueText}
                            title={traducirMessage(298)}
                            autoComplete="on"
                            InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                    <React.Fragment>
                                        {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                        {params.InputProps.endAdornment}
                                    </React.Fragment>
                                ),
                            }}
                            />
                            
                    )}
                />
            }
            {!required &&
                <Autocomplete
                    options={options}
                    defaultValue={value}
                    getOptionSelected={(option, value) => option.clave === value.clave}
                    getOptionLabel={option => option.descripcionVista ? option.descripcionVista : ''}
                    filterOptions={filterOptions}
                    onChange={handleChange}
                    renderOption={(option, { selected }) => (

                        <>

                            <Box display="flex" flexDirection="column" fontSize={14}>
                                <Box fontWeight="fontWeightLight" fontSize={12}>
                                    {option.descripcionVista}
                                </Box>
                            </Box>
                        </>
                    )}

                    loading={loading}
                    renderInput={params => (
                            <TextValidator
                            {...params}
                            onChange={textChange}
                            fullWidth
                            errorMessages={[traducirLabel(25)]}
                            name={name}
                            value={valueText}
                            title={traducirMessage(298)}
                            autoComplete="on"
                            InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                    <React.Fragment>
                                        {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                        {params.InputProps.endAdornment}
                                    </React.Fragment>
                                ),
                            }}
                            />
                            
                    )}
                />
            }
        </>
    );
};

export default AutocompleteMercanciaControl;